import { Buffer } from 'buffer';

export function getPayload(token: string): any {
    return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString('utf-8'));
}
